export const buildPartnersSlides = (widget, environment) => {
    if (!widget || !widget.data || !widget.data.length) {
        return [];
    }

    const slides = widget.data
        .filter(item => {
            if (!environment) return false;
            return item[environment] === true;
        })
        .sort((a, b) => a.order - b.order)
        .map(item => {
            return {
                id: item.id,
                file_path: item.file_path,
                img_desktop: item.img_desktop,
                title: item.title,
                type: 'partner'
            };
        });

    slides.push({
        id: 'all-partners',
        type: 'all-partners'
    });

    return slides;
};
